const ID = 'footer';

export default ID;
